/**
 * Horizon overrides for Shopify.actions and Deskmith canonical product routes.
 */

const DESKMITH_PRODUCT_ROUTES = new Map([
  ['/products/nature-walnut-solid-walnut-standing-desk', '/products/solid-black-walnut-standing-desk'],
  ['/products/bf51-standing-desk', '/products/solid-black-walnut-standing-desk'],
  ['/products/bf51', '/products/solid-black-walnut-standing-desk'],
  ['/products/nature-oak-solid-white-oak-standing-desk', '/products/solid-white-oak-standing-desk'],
  ['/products/bf31-standing-desk', '/products/solid-white-oak-standing-desk'],
  ['/products/bf31', '/products/solid-white-oak-standing-desk'],
  ['/products/ease-ergonomic-smart-standing-desk', '/products/ergonomic-standing-desk'],
  ['/products/bf11-standing-desk', '/products/ergonomic-standing-desk'],
  ['/products/bf11', '/products/ergonomic-standing-desk'],
  ['/products/essential-one-smart-standing-desk', '/products/smart-standing-desk'],
  ['/products/bf81-standing-desk', '/products/smart-standing-desk'],
  ['/products/bf81', '/products/smart-standing-desk'],
  ['/products/k100-monitor-arm', '/products/gas-spring-monitor-arm'],
  ['/products/desk-mat', '/products/napa-leather-desk-mat'],
  ['/products/drawer-under-desk-drawer', '/products/under-desk-drawer'],
  ['/products/casters-locking-desk-casters', '/products/standing-desk-casters'],
]);

function canonicalProductPath(pathname) {
  const normalized = pathname.length > 1 ? pathname.replace(/\/$/, '') : pathname;
  return DESKMITH_PRODUCT_ROUTES.get(normalized) || normalized;
}

function canonicalizeProductLinks(root = document) {
  root.querySelectorAll('a[href*="/products/"]').forEach((link) => {
    const url = new URL(link.href, window.location.origin);
    const canonical = canonicalProductPath(url.pathname);
    if (canonical !== url.pathname) {
      url.pathname = canonical;
      link.href = `${url.pathname}${url.search}${url.hash}`;
    }
  });
}

function enforceCanonicalProductRoute() {
  const canonical = canonicalProductPath(window.location.pathname);
  if (canonical !== window.location.pathname) {
    window.location.replace(`${canonical}${window.location.search}${window.location.hash}`);
    return true;
  }
  canonicalizeProductLinks();
  return false;
}

function init() {
  if (enforceCanonicalProductRoute()) return;

  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// This asset is part of cached theme documents. Keeping canonicalization here
// makes old Shopify page-cache entries safe while their HTML expires.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}

document.addEventListener('shopify:section:load', () => canonicalizeProductLinks());
